import {
    AdobeColoredIcon,
    AdobePhotoShopIcon,
    ApacheSparkIcon,
    CanvaIcon,
    ChatGptIcon,
    FigmaColoredIcon,
    JavaIcon,
    MongoDBIcon,
    NodeJsColorIcon,
    PostgresqlColorIcon,
    PythonIcon,
    PytorchIcon,
    SalesforceIcon,
    ShopifyIcon,
    SpringbootColorIcon,
    TensorflowIcon,
    WixIcon,
    WordPressIcon,
} from '../icons';

export const expertiseData = [
    {
        description:
            'Transforming the way people connect and engage with your brand via digital solutions and experiences to achieve a return on innovation.',
        icons: [FigmaColoredIcon, CanvaIcon, AdobePhotoShopIcon, AdobeColoredIcon],
        title: 'Product & Experience Design',
    },
    {
        description:
            'Creating scalable, high-performance digital products designed to meet your unique needs and drive lasting impact.',
        icons: [JavaIcon, NodeJsColorIcon, MongoDBIcon, PostgresqlColorIcon, SpringbootColorIcon],
        title: 'Product Development',
    },
    {
        description:
            'Empowering rapid innovation by leveraging no-code platforms to launch and refine digital solutions that drive results.',
        icons: [WordPressIcon, ShopifyIcon, WixIcon, SalesforceIcon],
        title: 'No/Low Code Development',
    },
    {
        description:
            'Driving business growth through the implementation of advanced AI and machine learning solutions that unlock new opportunities.',
        icons: [PythonIcon, PytorchIcon, TensorflowIcon, ApacheSparkIcon, ChatGptIcon],
        title: 'AI/ML Gen AI Solutions',
    },
];
